import React, { memo } from 'react';

import PropTypes from 'prop-types';

import ContentView from './contentView';
import Wrapper from './wrapper';

const PrimaryDataWrapper = ({
  config,
  data,
  isButtonsVisible = false,
  dataTestId,
  dataChanges,
  dataAuthors,
  removeBottomMargin = false,
  additionalContent,
}) => {
  return (
    <Wrapper
      config={config}
      dataTestId={dataTestId}
      isButtonsVisible={isButtonsVisible}
      removeBottomMargin={removeBottomMargin}
    >
      {additionalContent}
      <ContentView
        config={config.content}
        data={data}
        dataAuthors={dataAuthors}
        dataChanges={dataChanges}
      />
    </Wrapper>
  );
};

PrimaryDataWrapper.propTypes = {
  config: PropTypes.object.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isButtonsVisible: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  dataChanges: PropTypes.object,
  // Pending-change author rows by field name, shown as dots next to a changed field.
  dataAuthors: PropTypes.object,
  removeBottomMargin: PropTypes.bool,
  additionalContent: PropTypes.node,
};

export default memo(PrimaryDataWrapper);
